export const REG_EXP_TAG = '[object RegExp]';
